import { render, staticRenderFns } from "./areaAdminPageTransfer.vue?vue&type=template&id=080004da&scoped=true"
import script from "./areaAdminPageTransfer.vue?vue&type=script&lang=js"
export * from "./areaAdminPageTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080004da",
  null
  
)

export default component.exports